import React from 'react';
import { StyledBadge, StyledCross, StyledBadgeInfo, StyledContainer, StyledTextContainer, StyledBadgeWarning, StyledBadgeError, StyledBadgeSuccess, StyledContainerError } from './styled';
import ReactDOM from 'react-dom';

type NotificationBarProps = {
  
  text: string;
  text2?: string;
  timeout?: number; // number – seconds
  closable?: boolean;
}

const closeNotification = () => {
 ReactDOM.unmountComponentAtNode(document.getElementById("notification-bar") as HTMLElement)
 };
 const closeNetworkNotification = () => {
  ReactDOM.unmountComponentAtNode(document.getElementById("notification-bar-network") as HTMLElement)
  };
  const closeTestnetNetworkNotification = () => {
    ReactDOM.unmountComponentAtNode(document.getElementById("notification-bar-network-testnet") as HTMLElement)
    };

  export function NotificationBarInfo({text, text2, timeout, closable} : NotificationBarProps): JSX.Element {
    return (
      <StyledContainer style={{animation: timeout ? 'fadeOut 0.5s forwards' : '', animationDelay: timeout + 's'}}>
        <StyledBadgeInfo />
        <StyledTextContainer>
          <p>{text}</p>
          <p>{text2}</p>
        </StyledTextContainer>
        {(closable ? <StyledCross  onClick={closeNotification} /> : '')}
      </StyledContainer>
    );
  }
export default function NotificationBarWarning({text, text2, timeout, closable} : NotificationBarProps): JSX.Element {
  return (
    <StyledContainer style={{animation: timeout ? 'fadeOut 0.5s forwards' : '', animationDelay: timeout + 's'}}>
      <StyledBadgeWarning />
      <StyledTextContainer>
        <p>{text}</p>
        <p>{text2}</p>
      </StyledTextContainer>
      {(closable ? <StyledCross  onClick={closeNotification} /> : '')}

    </StyledContainer>
  );
}
export function NotificationBarError({text, text2, timeout, closable} : NotificationBarProps): JSX.Element {
  return (
    <StyledContainerError style={{animation: timeout ? 'fadeOut 0.5s forwards' : '', animationDelay: timeout + 's'}}>
      <StyledBadgeError />
      <StyledTextContainer>
        <p>{text}</p>
        <p>{text2}</p>
      </StyledTextContainer>
      {(closable ? <StyledCross  onClick={closeNotification} /> : '')}

    </StyledContainerError>
  );
}
export function NotificationBarSuccess({text, text2, timeout, closable} : NotificationBarProps): JSX.Element {
  return (
    <StyledContainer style={{animation: timeout ? 'fadeOut 0.5s forwards' : '', animationDelay: timeout + 's'}}>
      <StyledBadgeSuccess />
      <StyledTextContainer>
        <p>{text}</p>
        <p>{text2}</p>
      </StyledTextContainer>
      {(closable ? <StyledCross  onClick={closeNotification} /> : '')}

    </StyledContainer>
  );
}
export function NotificationBarNetwork({text, text2, timeout, closable} : NotificationBarProps): JSX.Element {
  return (
    <StyledContainer style={{animation: timeout ? 'fadeOut 0.5s forwards' : '', animationDelay: timeout + 's'}}>
      <StyledBadgeWarning />
      <StyledTextContainer>
        <p>{text}</p>
        <p>{text2}</p>
      </StyledTextContainer>
      {(closable ? <StyledCross  onClick={closeNetworkNotification} /> : '')}

    </StyledContainer>
  );
}
export function NotificationBarTestnet({text, text2, timeout, closable} : NotificationBarProps): JSX.Element {
  return (
    <StyledContainer style={{animation: timeout ? 'fadeOut 0.5s forwards' : '', animationDelay: timeout + 's'}}>
      <StyledBadgeInfo />
      <StyledTextContainer>
        <p>{text}</p>
        <p>{text2}</p>
      </StyledTextContainer>
      {(closable ? <StyledCross  onClick={closeTestnetNetworkNotification} /> : '')}

    </StyledContainer>
  );
}

export function renderNotification(messageText : any, type: string, timeout?: number, closable?: boolean)
{
  ReactDOM.unmountComponentAtNode(document.getElementById("notification-bar") as HTMLElement)
  if (type === "info")
  ReactDOM.render( <NotificationBarInfo timeout={timeout} text={messageText} closable={closable}/>, document.getElementById("notification-bar"))
  else if (type === "warning")
  ReactDOM.render( <NotificationBarWarning timeout={timeout} text={messageText} closable={closable}/>, document.getElementById("notification-bar"))
  else if (type === "error")
  ReactDOM.render( <NotificationBarError timeout={timeout} text={messageText} closable={closable}/>, document.getElementById("notification-bar"))
  else if (type === "success")
  ReactDOM.render( <NotificationBarSuccess timeout={timeout} text={messageText} closable={closable}/>, document.getElementById("notification-bar"))
  //if (timeout)
 // setTimeout( function() { ReactDOM.unmountComponentAtNode(document.getElementById("notification-bar") as HTMLElement); }, timeout * 1000 + 500) // 500 – 0.5 seconds (fade out time);
}
